import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let ga: Function;

// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(public router: Router, public authService: BfAuthService) {
    this.router.events.subscribe((event) => {
      try {
        // Univeral-Analytics logging
        if (typeof ga === 'function') {
          if (event instanceof NavigationEnd) {
            ga('set', 'page', event.urlAfterRedirects);
            if (authService.profileId != null && authService.profileId > 0) {
              ga('set', 'userId', authService.profileId.toString());
            }
            ga('send', 'pageview');

          }
        }
        // GA4 logging
        if (typeof gtag === 'function') {
          if (event instanceof NavigationEnd) {
            gtag('event', 'page_view', {
              page_path: event.urlAfterRedirects
            });

            if (authService.profileId != null && authService.profileId > 0) {
              gtag('config', 'G-JK0N8YVQ86', {
                'user_id': authService.profileId.toString()
              });
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  /**
   * Emit google analytics event
   * Fire event example:
   *
   * @param  eventCategory
   * @param  eventAction
   * @param  eventLabel
   * @param  eventValues
   */
  public emitEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string | null = null,
    eventValue: number | null = null,
  ) {
    if (typeof ga === 'function') {
      ga('send', 'event', {
        eventCategory,
        eventLabel,
        eventAction,
        eventValue,
      });
    }
  }
}
